// import React, { useState, useEffect } from 'react';
// import { DataGrid, GridToolbar } from "@mui/x-data-grid";
// import { Box, Typography, Tooltip, Modal } from '@mui/material';
// import Header from "../../components/Header";
// import { useTheme } from "@mui/material";
// import { tokens } from "../../theme";

// function AppliedLeaves() {
//   const [applications, setApplications] = useState([]);
//   const theme = useTheme();
//   const userEmail = localStorage.getItem('UserEmail') || '';
//   const colors = tokens(theme.palette.mode);
//   const [message, setMessage] = useState('');
//   const [selectedComment, setSelectedComment] = useState('');
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   useEffect(() => {
//     fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application/details`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({ userEmail }),
//     })
//       .then(response => response.json())
//       .then(data => setApplications(data))
//       .catch(error => console.error(error));
//   }, [userEmail]);

//   const handleCommentClick = (comment) => {
//     setSelectedComment(comment);
//     setIsModalOpen(true);
//   };

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//   };

//   const columns = [
//     { field: 'applicationno', headerName: 'ID', flex: 1 },
//     { field: 'leavetype', headerName: 'Leave Type', flex: 1 },
//     { field: 'startingdate', headerName: 'Start Date', flex: 1 },
//     { field: 'startingdateleavesession', headerName: 'Half Day', flex: 1,
//       renderCell: (params) => {
//         const { value } = params;
//         if (value === 1) {
//           return 'First Half';
//         } else if (value === 2) {
//           return 'Second Half';
//         } else {
//           return '-';
//         }
//       }
//     },
//     { field: 'endingdate', headerName: 'End Date', flex: 1 },

//     { field: 'ApplyingDate', headerName: 'Applying Date', flex: 1 },

//     {
//       field: 'LeavePurpose', headerName: 'Reason', flex: 1,
//       renderCell: (params) => {
//         const { value } = params;
//         const maxLength = 12; // Set the maximum length for the reason

//         if (value.length > maxLength) {
//           return (
//             <Tooltip title={value} placement="top-start">
//               <div>{value}</div>
//             </Tooltip>
//           );
//         }

//         return <div>{value}</div>;
//       }
//     },
//     {
//       field: 'Comments',
//       headerName: 'Comments',
//       flex: 1,
//       renderCell: (params) => {
//         const commentText = params.value || ''; // Ensure value is a string
//         const truncatedText = commentText.length > 15 ? `${commentText.substring(0, 15)}...` : commentText;

//         return (
//           <Typography
//             sx={{ cursor: 'pointer', color: 'blue' }}
//             onClick={() => handleCommentClick(commentText)} // Ensure it passes a valid value
//           >
//             {truncatedText}
//           </Typography>
//         );
//       }
//     },

//     { field: 'ApplicationStatus', headerName: 'Status', flex: 1, editable: true,
//       renderCell: (params) => {
//         const currentStatus = params.row.ApplicationStatus;
//         const startingDate = new Date(params.row.startingdate);
//         const current = new Date();
//         const today = new Date(current.getFullYear(), current.getMonth(), current.getDate());

//         // Use a fallback value of false for user_want_cancel if it is undefined
//         const userWantCancel = params.row.user_want_cancel !== undefined ? params.row.user_want_cancel : false;

//         const backgroundColor = currentStatus === 'PENDING' && userWantCancel === true ? 'yellow' : 'transparent';

//         const cellStyle = { backgroundColor };

//         if ((currentStatus === 'REJECTED' || currentStatus === 'CANCELLED') && (startingDate <= today)) {
//           return (
//             <div style={{ color: 'red', textAlign: 'center' }}>
//               CANCELLED
//             </div>
//           );
//         } else if (currentStatus === 'REJECTED' && startingDate > today  && (params.row.user_want_cancel == null  || params.row.user_want_cancel  == undefined ) ) {
//           return (
//             <div style={{ color: 'red', textAlign: 'center' }}>
//               REJECTED
//             </div>
//           );
//         } else if (currentStatus === 'CANCELLED' && startingDate > today  &&  (params.row.user_want_cancel == null  || params.row.user_want_cancel  == undefined )) {
//           return (
//             <div style={{ color: 'red', textAlign: 'center' }}>
//               CANCELLED
//             </div>
//           );
//         } else if (currentStatus === 'APPROVED' && startingDate <= today &&  (params.row.user_want_cancel == null  || params.row.user_want_cancel  == undefined )  ) {
//           return (
//             <div style={{ color: 'green', textAlign: 'center' }}>
//               APPROVED
//             </div>
//           );
//         } else if (currentStatus === 'APPROVED' && startingDate > today && (params.row.user_want_cancel == null  || params.row.user_want_cancel  == undefined ) ) {
//           return (
//             <div style={{ color: 'green', textAlign: 'center' }}>
//               <select
//                 value={params.value}
//                 onChange={(event) => handleUpdate(params.row.applicationno, event.target.value)}
//               >
//                 <option value="APPROVED">APPROVED</option>
//                 <option value="CANCELLED">CANCEL</option>
//               </select>
//             </div>
//           );
//         } else if(params.row.user_want_cancel  != undefined  || params.row.user_want_cancel != null){

//        return(
//           <div>
//             CANCELLAtION- {currentStatus}
//           </div>
//        );

//         }else{
//           return (
//             <select
//               value={params.value}
//               onChange={(event) => handleUpdate(params.row.applicationno, event.target.value)}
//             >
//               <option value="PENDING">PENDING</option>

//             </select>
//           );
//         }
//       },
//     },
//     { field: "noofdays", headerName: 'No Of Days', flex: 1 },

//     { field: 'ActualApproveLeave', headerName: 'ActualApproveLeave', flex: 1 ,

//       renderCell: (params) => {

//         if(params.row.ActualApproveLeave > 0 &&( params.row.ApplicationStatus === 'APPROVED' || params.row.ApplicationStatus === 'PENDING') ){
//           return   <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{params.value}</div>;

//         }else if(params.row.ApplicationStatus === 'APPROVED'){

//         return   <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{params.row.noofdays}</div>;
//         }

//       }
//     }
//   ];

//   const handleUpdate = (applicationno, status) => {
//     const updatedRow = applications.find(application => application.applicationno === applicationno);
//     const updatedApplications = applications.map(application => {
//       if (application.applicationno === applicationno) {
//         return { ...application, ApplicationStatus: status === "CANCELLED" ? `CANCELLATION-${application.ApplicationStatus}` : status };
//       }
//       return application;
//     });

//     // Handle the "CANCEL" action and call the new API
//     if (status === "CANCELLED") {
//       const cancelRequestData = {
//         application_no: applicationno,
//         user_want_cancel: true
//       };

//       const requestOptions = {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(cancelRequestData)
//       };

//       fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/update_leave_application`, requestOptions)
//         .then(res => res.json())
//         .then(data => {
//           setMessage(data.message); // Update the message state with the response message
//           setApplications(updatedApplications); // Update the applications state with the updated status

//           fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application/details`, {
//             method: 'POST',
//             headers: {
//               'Content-Type': 'application/json',
//             },
//             body: JSON.stringify({ userEmail }),
//           })
//             .then(response => response.json())
//             .then(data => setApplications(data))
//             .catch(error => console.error(error));

//         })
//         .catch(error => {
//           console.error(error);
//           setMessage('Error updating leave application');
//         });
//     } else {
//       setApplications(updatedApplications); // Update the applications state with the updated status for other actions
//       setMessage('Status updated successfully');
//     }

//   };

//   return (
//     <Box m="20px">
//       <Header title="Applied Leaves" subtitle="List of Leaves" />
//       {message && <Typography variant="body1" sx={{ color: 'green' }}>{message}</Typography>}
//       <Box height="75vh" sx={{
//         "& .MuiDataGrid-root": {
//           border: "none",
//         },
//         "& .MuiDataGrid-cell": {
//           borderBottom: "none",
//         },
//         "& .name-column--cell": {
//           color: colors.greenAccent[300],
//         },
//         "& .MuiDataGrid-columnHeaders": {
//           backgroundColor: colors.blueAccent[700],
//           borderBottom: "none",
//         },
//         "& .MuiDataGrid-virtualScroller": {
//           backgroundColor: colors.primary[400],
//         },
//         "& .MuiDataGrid-footerContainer": {
//           borderTop: "none",
//           backgroundColor: colors.blueAccent[700],
//         },
//         "& .MuiCheckbox-root": {
//           color: `${colors.greenAccent[200]} !important`,
//         },
//         "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
//           color: `${colors.grey[100]} !important`,
//         },
//       }}>
//         <DataGrid
//           rows={applications}
//           columns={columns}
//           components={{ Toolbar: GridToolbar }}
//           pagination
//           pageSize={10}
//           rowsPerPageOptions={[10, 25, 50]}
//           checkboxSelection
//           autoHeight
//           hideFooterSelectedRowCount
//           getRowId={(row) => row.applicationno}
//         />
//       </Box>

//       <Modal open={isModalOpen} onClose={handleCloseModal}>
//         <Box
//           id="comment-modal"
//           onClick={handleCloseModal}
//           sx={{
//             position: 'fixed',
//             top: 0, left: 0, width: '100%', height: '100%',
//             display: 'flex', justifyContent: 'center', alignItems: 'center',
//             backgroundColor: 'rgba(0, 0, 0, 0.5)'
//           }}
//         >
//           <Box
//             sx={{
//               backgroundColor: 'white', padding: 3, borderRadius: 2, boxShadow: 24,
//               minWidth: '300px', maxWidth: '500px', textAlign: 'center', color:"black"
//             }}
//             onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
//           >
//             <Typography variant="h6">Full Comment</Typography>
//             <Typography>{selectedComment}</Typography>
//           </Box>
//         </Box>
//       </Modal>

//     </Box>
//   );
// }

// export default AppliedLeaves;

import React, { useState, useEffect } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  Box,
  Typography,
  Tooltip,
  TextField,
  MenuItem,
  Select,
  Button,
  FormControl,
  InputLabel,
  Tabs,
  Tab,
} from "@mui/material";
import Header from "../../components/Header";
import { useTheme } from "@mui/material";
import axios from "axios";
import { tokens } from "../../theme";

function AppliedLeaves() {
  const [applications, setApplications] = useState([]);
  const theme = useTheme();
  const userEmail = localStorage.getItem("UserEmail") || "";
  const colors = tokens(theme.palette.mode);
  const [message, setMessage] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [comments, setComments] = useState({});
  const currentYear = new Date().getFullYear();
  const [loading, setLoading] = useState(true);
  const [selectedTab, setSelectedTab] = useState(0);
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
  const yearOptions = Array.from(
    { length: currentYear - 2000 + 1 },
    (_, index) => 2000 + index
  );
  const [filteredLeaves, setFilteredLeaves] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [tentativeLeaves, setTentativeLeaves] = useState([]);
  const [nonTentativeLeaves, setNonTentativeLeaves] = useState([]);

  useEffect(() => {
    setLoading(true);
    fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/application/details`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${accessToken}`
      },
      body: JSON.stringify({ userEmail }),
    })
      .then((response) => response.json())
      .then((data) => {
        setApplications(data);
        filterLeaves(data);
      })
      .catch((error) => console.error(error));
      setLoading(false);
      
  }, [userEmail]);


    const filterLeaves = (applications) => {
        if (!selectedYear) return;

        const yearFiltered = applications.filter((leave) => {
            if (!leave.startingdate) return false;
            const leaveYear = new Date(leave.startingdate).getFullYear();
            return leaveYear === selectedYear;
        });


        const tentativeLeaves = yearFiltered.filter((leave) => {
            return leave.leavetype === "TL";
        });


        const nonTentativeLeaves = yearFiltered.filter((leave) =>
            leave.leavetype !== "TL"
        );

        const getStatusPriority = (status) => STATUS_PRIORITY[status?.toUpperCase()] || 0;
        const getTentativeStatusPriority = (status) => tentative_STATUS_PRIORITY[status?.toUpperCase()] || 0;

        nonTentativeLeaves.sort((a, b) =>
            getStatusPriority(a.ApplicationStatus) - getStatusPriority(b.ApplicationStatus)
        );

        tentativeLeaves.sort((a, b) =>
            getTentativeStatusPriority(a.ApplicationStatus) - getTentativeStatusPriority(b.ApplicationStatus)
        );

        if (selectedTab === 0) {
            setFilteredLeaves(nonTentativeLeaves);
            setNonTentativeLeaves(nonTentativeLeaves);
        } else if (selectedTab === 1) {
            setFilteredLeaves(tentativeLeaves);
            setTentativeLeaves(tentativeLeaves);
        }

    };


    useEffect(() => {
        if (!applications || applications.length === 0) {
            console.log("No applications available.");
            return;
        }
        filterLeaves(applications);
    }, [selectedYear, applications, selectedTab]);

    useEffect(() => {
    
    }, [filteredLeaves]);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue); 
        if (newValue === 0) {
          setFilteredLeaves(nonTentativeLeaves);
        } else if (newValue === 1) {
          setFilteredLeaves(tentativeLeaves);
        }
    };


  const handleDownloadFiles = (uploadedFiles) => {
    if (!uploadedFiles || Object.keys(uploadedFiles).length === 0) {
      alert("No files to download.");
      return;
    }

    // Open each file URL in a new tab
    Object.values(uploadedFiles).forEach((fileUrl) => {
      window.open(fileUrl, "_blank");
    });
  };
  const STATUS_PRIORITY = {
    "PENDING": 1,
    "CANCEL-PENDING": 3,
    "APPROVED": 2,
    "REJECTED": 6,
    "CANCELLED": 4,
    "CANCEL_REJECTED":5,
  };

  const tentative_STATUS_PRIORITY = {
    "Tentative":1,
    "PENDING": 2,
    "CANCEL-PENDING": 4,
    "APPROVED": 3,
    "REJECTED": 7,
    "CANCELLED": 5,
    "CANCEL_REJECTED":6,
  };
//   const filterApprovedLeaves = () => {
//     if (!selectedYear) return;

//     const leavesForYear = applications.filter((leave) => {
//       if (!leave.startingdate) return false; // Ensure startingdate exists

//       const leaveYear = new Date(leave.startingdate).getFullYear();
//       return leaveYear === selectedYear;
//     });

//     // Sort based on STATUS_PRIORITY mapping
//     leavesForYear.sort((a, b) => (STATUS_PRIORITY[a.ApplicationStatus] - STATUS_PRIORITY[b.ApplicationStatus]));

//     console.log("Filtered Leaves:", leavesForYear); // Debugging line
//     setFilteredLeaves(leavesForYear);
// };

// // Re-filter leaves when selectedYear or applications change
// useEffect(() => {
//     filterApprovedLeaves();
// }, [selectedYear, applications]);

const handleYearChange = (event) => {
    setSelectedYear(parseInt(event.target.value, 10));
};

  const handleRowSelection = (newSelection) => {
    setSelectedRows(newSelection);
  };

  const handleCommentChange = (applicationNo, value) => {
    setComments((prev) => ({
      ...prev,
      [applicationNo]: value,
    }));
  };


    const handleUpdate = async (applicationno, currentStatus) => {

      try {
        const newStatus =
          currentStatus === "PENDING"
            ? "CANCELLED"
            : currentStatus === "APPROVED"
            ? "CANCEL-PENDING"
            : currentStatus;
          

          if (newStatus === currentStatus) {
            setMessage("No status change required.");
            return;
          }
      
        const updatedApplications = applications.map((application) =>
          application.applicationno === applicationno
            ? { ...application, ApplicationStatus: newStatus }
            : application
        );
    
        
        setApplications(updatedApplications);

          const cancelRequestData = {
            application_no: applicationno,
            new_status: newStatus,
            user_want_cancel: true,
            employee_comment: comments[applicationno] || "",
          };
          
    
          const response = await fetch(
            `${process.env.REACT_APP_BACKEND_URL_LMS}/update_leave_application`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" ,'Authorization': `Bearer ${accessToken}`},
              body: JSON.stringify(cancelRequestData),
            }
          );
    
          const result = await response.json();
    
          setMessage(result.message);
    
       
          const updatedResponse = await fetch(
            `${process.env.REACT_APP_BACKEND_URL_LMS}/application/details`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json",'Authorization': `Bearer ${accessToken}` },
              body: JSON.stringify({ userEmail }),
            }
          );
    
          const updatedData = await updatedResponse.json();
    
          setApplications(updatedData);
          setSelectedRows((prev) => {
            const newSelectedRows = prev.filter((appNo) => appNo !== applicationno);
            return newSelectedRows;
          });
      } catch (error) {
        setSelectedRows((prev) => prev.filter((appNo) => appNo !== applicationno));
        setMessage("Error updating leave application");
      }
    };


    const handleApply = async (applicationNo) => {
      try {
        
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_LMS}/apply-tetative`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            applicationno: applicationNo,
            newStatus: "PENDING", 
            employee_comment: comments[applicationNo] || "",
          }),
        });
    
        const result = await response.json();
        setMessage(result.message); 

        setApplications((prevApplications) => {
          return prevApplications.map((application) =>
            application.applicationno === applicationNo
              ? { ...application, ApplicationStatus: "PENDING" }
              : application
          );
        });
      } catch (error) {
        console.error("Failed to apply leave:", error);
        setMessage("Error submitting application.");
      }
    };
    

  const columns = [
 
    {
      field: "leavetype",
      headerName: "Leave Type",
      flex: 1,
      valueGetter: (params) => {
        const type = params.row.leavetype;
        if (type === "EL") return "Emergency Leave";
        if (type === "PL") return "Planned Leave";
        if (type === "TL" || type === "Tentative_Leave_Plan") return "Tentative Leave";
        return type;
      }
    },
    {
  field: "displayStartDate",
  headerName: "Start Date",
  flex: 1,
  valueGetter: (params) => {
    return params.row.ApprovedStartingDate || params.row.startingdate || "";
  },
},
{
  field: "displayEndDate",
  headerName: "End Date",
  flex: 1,
  valueGetter: (params) => {
    return params.row.ApprovedEndingDate || params.row.endingdate || "";
  },
},

    {
      field: "LeavePurpose",
      headerName: "Reason",
      flex: 1,
      renderCell: (params) => {
        const { value } = params;
        const maxLength = 12; 

        if (value.length > maxLength) {
          return (
            <Tooltip title={value} placement="top-start">
              <div>{value}</div>
            </Tooltip>
          );
        }

        return <div>{value}</div>;
      },
    },
    {
      field: "Comments",
      headerName: "Comments",
      flex: 1,
      renderCell: (params) => {
        const commentText = params.value || ""; // Ensure value is a string
        const truncatedText =
          commentText.length > 15
            ? `${commentText.substring(0, 15)}...`
            : commentText;

        return (
          <Typography
            sx={{ cursor: "pointer", color: "blue" }}
          
          >
            {truncatedText}
          </Typography>
        );
      },
    },
    {
      field: "ApplicationStatus",
      headerName: "Status",
      flex: 1,
      editable: true,
      renderCell: (params) => {
        const currentStatus = params.row.ApplicationStatus;
        const startingDate = new Date(params.row.startingdate);
        const current = new Date();
        const today = new Date(
          current.getFullYear(),
          current.getMonth(),
          current.getDate()
        );

        const textColor =
        currentStatus === "APPROVED"
          ? "#28A745" // Green
          : currentStatus === "CANCELLED"
          ? "#FF6F61" // Dark orange with red
          : currentStatus === "REJECTED"
          ? "#D32F2F"     // Brighter red for better contrast in dark mode
          : currentStatus === "CANCEL-PENDING"
          ? "#FD7E14" // Orange
          : currentStatus === "PENDING"
          ? "#007BFF"
          : currentStatus === "TENTATIVE"
          ? "#FF9800" 
          : "#E67E22";
        return (
          <div
            style={{
              color: textColor,
              textAlign: "center",
              fontWeight: "bold",
            }}
          >
            {currentStatus}
          </div>
        );
      },
    },
    { field: "noofdays", headerName: "No Of Days", flex: 1 },
    {
      field: "ActualApproveLeave",
      headerName: "ActualApproveLeave",
      flex: 1,
      renderCell: (params) => {
        if (
          params.row.ActualApproveLeave > 0 &&
          (params.row.ApplicationStatus === "APPROVED" ||
            params.row.ApplicationStatus === "PENDING")
        ) {
          return (
            <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
              {params.value}
            </div>
          );
        } else if (params.row.ApplicationStatus === "APPROVED") {
          return (
            <div style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
              {params.row.noofdays}
            </div>
          );
        }
      },
    },
    {
      field: "uploaded_files",
      headerName: "Uploaded Files",
      flex: 1,
      renderCell: (params) => {
        const uploadedFiles = params.row.uploaded_files || {};
        const fileCount = Object.keys(uploadedFiles).length;

        return (
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleDownloadFiles(uploadedFiles)}
            disabled={fileCount === 0}
          >
            {fileCount} File(s)
          </Button>
        );
      },
    },
  ];
  

 

  return (
    <Box m="20px">
      <Header title="Applied Leaves" subtitle="List of Leaves" />
      {message && (
        <Typography variant="body1" sx={{ color: "green" }}>
          {message}
        </Typography>
      )}
     <Tabs
        value={selectedTab}
        onChange={handleTabChange}
        variant="fullWidth"
        textColor="inherit"
        indicatorColor="secondary"
        TabIndicatorProps={{
          style: {
            height: "4px",
            backgroundColor: colors.greenAccent[600],
            borderRadius: '2px 2px 0 0',
          },
        }}
        sx={{
          mb: 4,
          backgroundColor: theme.palette.background.default,
          borderRadius: "8px",
          borderBottom: `1px solid ${colors.grey[300]}`,
        }}
      >
        <Tab label="All Leaves" />
        <Tab label="Tentative Leaves" />
      </Tabs>
      <Box m="20px 0">
      <FormControl fullWidth>
        <InputLabel
          shrink
          sx={{
            color: "text.primary",
            fontWeight: "bold",
            fontSize: "18px",
            transform: "translate(14px, -9px) scale(0.75)",
            transformOrigin: "top left",
            "&.Mui-focused": {
              color: "text.primary",
            },
          }}
        >
          Year
        </InputLabel>

        <Select
          value={selectedYear}
          onChange={handleYearChange}
          label="Year"
          displayEmpty
          sx={{
            fontWeight: "bold",
            borderRadius: "8px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: "1px solid gray",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: "1px solid gray",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: "1px solid gray",
            },
            "& .MuiSvgIcon-root": {
              color: "#666",
            },
          }}
          MenuProps={{
            PaperProps: {
              style: {
                maxHeight: 200,
                overflowY: "auto",
              },
            },
          }}
        >
          {yearOptions.map((year) => (
            <MenuItem key={year} value={year}>
              {year}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      </Box>

      <Box
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
        }}
      >
        <DataGrid
          rows={loading ? [] : selectedTab === 1 ? tentativeLeaves : filteredLeaves}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
          pagination
          checkboxSelection
          autoHeight
          hideFooterSelectedRowCount
          getRowId={(row) => row.applicationno}
          onSelectionModelChange={(newSelection) => handleRowSelection(newSelection)}
          loading={loading}
          localeText={{ noRowsLabel: loading ? "Loading..." : "" }}
        />
      </Box>
      {/* Show comment box and buttons for selected rows */}
      {selectedRows.length > 0 && (
          <Box mt={10} p={2} sx={{ borderRadius: "8px",backgroundColor: colors.primary[400],   border: `1px solid ${colors.grey[300]}`, }}>
            <Typography variant="h6">Selected Applications</Typography>
            {selectedRows.map((applicationNo) => {
               const application = applications.find((app) => app.applicationno === applicationNo);
               return(
                <>
                    <Box key={applicationNo} mb={1}>
                      <Typography variant="subtitle1">
                        Application No: {applicationNo}
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        label="Enter Comment"
                        value={comments[applicationNo] || ""}
                        onChange={(e) => handleCommentChange(applicationNo, e.target.value)}
                        sx={{ mt: 1 }}
                      />
                      <Box mt={2} display="flex" gap={2}>
                        <Button
                          variant="outlined"
                          color="error"
                          onClick={() => {
                          
                            if (application) {
                              handleUpdate(application.applicationno, application.ApplicationStatus);
                            } else {
                              console.error(" Application not found for applicationNo:", applicationNo);
                            }
                          }}
                        >
                          Cancel Request
                        </Button>
                        {selectedTab === 1 &&
                          application?.leavetype === "TL" &&
                          application?.ApplicationStatus === "Tentative" && (
                            <Button
                              variant="contained"
                              color="success"
                              onClick={() => handleApply(application.applicationno)}
                            >
                              Apply Leave
                            </Button>
                          )}
                          </Box>
                    </Box>
                </>
                );
                
              })}
          </Box>
      )}
      
    </Box>
  );
}

export default AppliedLeaves;
